"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventJSONModel = void 0;
const lodash_1 = __importDefault(require("lodash"));
class EventJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetName();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.setName(serializedState.name);
            }
        };
        this.serialize = () => {
            return {
                name: this.name
            };
        };
        this.toEventQuery = () => {
            if (this.isFilled() && this.name) {
                return {
                    eventDescription: {
                        name: this.name
                    }
                };
            }
            return undefined;
        };
        ////////////////////////////////////////////////
        // Name
        ////////////////////////////////////////////////
        this.getName = () => this.name;
        this.setName = (name) => {
            if (lodash_1.default.isEmpty(name) || !lodash_1.default.isString(name)) {
                this.resetName();
            }
            else {
                this.name = name;
            }
        };
        this.resetName = () => {
            this.name = undefined;
        };
        ////////////////////////////////////////////////
        // Validation
        ////////////////////////////////////////////////
        this.isFilled = () => {
            return !lodash_1.default.isEmpty(this.getName());
        };
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.EventJSONModel = EventJSONModel;
